import { render, staticRenderFns } from "./Webshell.Detail.vue?vue&type=template&id=c38c13ae&"
import script from "./Webshell.Detail.vue?vue&type=script&lang=js&"
export * from "./Webshell.Detail.vue?vue&type=script&lang=js&"
import style0 from "./Webshell.Detail.vue?vue&type=style&index=0&id=c38c13ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports